var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit icon-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.96268 1.07464H2.74067C1.77932 1.07464 1 1.85396 1 2.81531V13.2593C1 14.2207 1.77932 15 2.74067 15H13.1847C14.1461 15 14.9254 14.2207 14.9254 13.2593V8.0373M13.5452 4.91648L14.4902 3.9715C15.1699 3.29173 15.1699 2.1896 14.4902 1.50983C13.8104 0.830055 12.7083 0.830055 12.0285 1.50984L11.0835 2.4548M13.5452 4.91648L8.29158 10.1701C8.04859 10.4131 7.73909 10.5788 7.40219 10.6462L4.84185 11.1582L5.35391 8.59797C5.42131 8.26097 5.58695 7.95148 5.82994 7.70848L11.0835 2.4548M13.5452 4.91648L11.0835 2.4548",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserIcon);
export default __webpack_public_path__ + "static/media/edit_user_icon.8339be2ace1e1ab77542716ab642ea2f.svg";
export { ForwardRef as ReactComponent };